import { render, staticRenderFns } from "./occurrence.vue?vue&type=template&id=2c6013cd&scoped=true&"
import script from "./occurrence.vue?vue&type=script&lang=js&"
export * from "./occurrence.vue?vue&type=script&lang=js&"
import style0 from "./occurrence.css?vue&type=style&index=0&id=2c6013cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6013cd",
  null
  
)

export default component.exports